import { ReloadOutlined } from "@ant-design/icons";
import { Col, Row, Spin } from "antd";
// import GiftOrder from "./giftOrder";
import _ from "lodash";
import moment from "moment";
import React, { memo, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import {
  ACCESS_TOKEN,
  // ORDER_STATUS_COLOR,
  ORDER_STATUS_PENDING,
  ORDER_STATUS_SUCCESS,
  PAYMENT_METHOD_COD,
  PAYMENT_METHOD_LABEL,
  PAYMENT_METHOD_MOMO,
  PAYMENT_METHOD_PAYOO,
  PAYMENT_METHOD_PAYOO_LIST,
  PAYMENT_METHOD_TRANSFER,
  PAYMENT_METHOD_VNPAY,
  PAYMENT_METHOD_VTPAY,
  PAYMENT_STATUS_REFUNDED,
  PAYMENT_STATUS_TRANSFER,
  WIDTH_MOBILE,
} from "../../common/constant";
import { order } from "../../services";
import { setTitlePage } from "../../utils/helper";
import CopyComponent from "../copyComponent";
import ConfirmCancelOrderModal from "../modal/confirmCancelOrderModal";
import RetryPayment from "../retryPayment";
import OrderPaymentCode from "./orderPaymentCode";
import ProductOrder from "./productOrder";
import ProductOrderGift from "./productOrderGift";
import StepOrderStatus from "./stepOrderStatus";
import "./style.scss";

const ProfileOrderDetail = memo((props: any) => {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);
  const { id } = useParams<any>();
  const [orderDetail, setOrderDetail] = useState<any>();
  const { breakPoint } = props;
  const [visible, setVisible] = useState(false);
  const { innerWidth } = window;

  useEffect(() => {
    fetchData(id);
  }, []);

  const fetchData = (id: string) => {
    setLoading(true);

    order.getOrder(id, (data, err) => {
      if (data) {
        setTitlePage(data.kde_order_id);
        setOrderDetail(data);
      }
      setLoading(false);
    });
  };

  const allowRetryPayment = () => {
    if (
      !(
        orderDetail.payment_transacion_id &&
        (orderDetail.payment_transacion_id.status === ORDER_STATUS_SUCCESS ||
          orderDetail.payment_transacion_id.status === PAYMENT_STATUS_REFUNDED)
      ) &&
      [
        ...PAYMENT_METHOD_PAYOO_LIST,
        PAYMENT_METHOD_MOMO,
        PAYMENT_METHOD_VNPAY,
      ].indexOf(orderDetail.payment_method) != -1 &&
      !orderDetail.order_status_reject &&
      orderDetail.order_status == ORDER_STATUS_PENDING
    ) {
      return true;
    }

    return false;
  };

  const allowCancelOrder = () => {
    const accessToken = localStorage.getItem(ACCESS_TOKEN);

    if (!accessToken) {
      return false;
    }

    if (
      !(
        orderDetail.payment_transacion_id &&
        (orderDetail.payment_transacion_id.status === ORDER_STATUS_SUCCESS ||
          orderDetail.payment_transacion_id.status === PAYMENT_STATUS_REFUNDED)
      ) &&
      !orderDetail.rejected &&
      orderDetail.order_status == ORDER_STATUS_PENDING
    ) {
      return true;
    }
    return false;
  };

  const renderPaymentStatus = () => {
    if (
      orderDetail.payment_method !== PAYMENT_METHOD_COD &&
      orderDetail.payment_method !== PAYMENT_METHOD_TRANSFER
    ) {
      // let srcImg = IconPaymentUnpaid;
      let textMessage = (
        <span
          className="main-content order-detail-bold order-status-title"
          style={{ color: "#f4511e" }}>
          Chưa thanh toán
        </span>
      );
      if (orderDetail.payment_transacion_id) {
        switch (orderDetail.payment_transacion_id.status) {
          case ORDER_STATUS_SUCCESS:
            // srcImg = IconPaymentPaid;
            textMessage = (
              <span
                className="main-content order-detail-bold order-status-title"
                style={{ color: "#45ade9" }}>
                Đã thanh toán
              </span>
            );
            break;
          case PAYMENT_STATUS_REFUNDED:
            // srcImg = IconPaymentRefunded;
            textMessage = (
              <span
                className="main-content order-detail-bold order-status-title"
                style={{ color: "#f4511e" }}>
                Đã hoàn tiền
              </span>
            );

            break;
        }
      }
      return (
        <div className="order-detail-payment-status">
          {/* <img src={srcImg} /> */}
          {textMessage}
          {allowRetryPayment() && (
            <RetryPayment
              {...props}
              order_id={orderDetail._id}
              kde_order_id={orderDetail.kde_order_id}
              payment_method={orderDetail.payment_method}
              order_detail={orderDetail}
              fetchData={fetchData}
            />
          )}
        </div>
      );
    }
    return null;
  };

  return (
    <Row justify="center" align="middle" className="kd-profile-container">
      <Col span={24}>
        <Row
          className="kd-profile-go-back"
          onClick={() => props.history.goBack()}>
          <img
            src="https://kdstore.s3-ap-southeast-1.amazonaws.com/static/imgs/arrow-tail.svg"
            alt=""
          />
          <span className="sub-content order-detail-bold">
            Quay lại trang danh sách đơn hàng
          </span>
        </Row>
        <Row justify="center" align="middle">
          <span className="main-title kd-profile-title">CHI TIẾT ĐƠN HÀNG</span>
          {/* <span className="main-content kd-profile-go-back">
            Quay lại trang thông tin
          </span> */}
        </Row>
        {/* <Row justify="start" align="middle">
          
        </Row> */}
        <Row justify="center" align="middle">
          <Col className="kd-profile-content-wrapper">
            <div
              className="kd-order-detail-layout"
              style={{ flexWrap: breakPoint ? "wrap" : "nowrap" }}>
              <div className="kd-order-detail-container">
                {loading ? (
                  <div className="loading-container">
                    <Spin />
                  </div>
                ) : orderDetail ? (
                  <div>
                    <Row
                      justify="center"
                      style={{ paddingLeft: 30, marginBottom: 30 }}>
                      <Col xs={24} sm={12}>
                        <Row>
                          <span className="sub-title title order-detail-text-uppercase">
                            {t("order_id")}:&nbsp;{orderDetail.kde_order_id}
                          </span>
                        </Row>
                        {orderDetail.order_voucher_code &&
                        orderDetail.order_voucher_code.code ? (
                          <Row style={{ marginBottom: 2 }}>
                            <span className="main-content title">
                              {t("shopping_cart_voucher_code_label")}:&nbsp;
                              {orderDetail.order_voucher_code.code}
                            </span>
                          </Row>
                        ) : null}
                        {orderDetail.order_voucher_code &&
                        orderDetail.order_voucher_code.name ? (
                          <Row style={{ marginBottom: 2 }}>
                            <span className="main-content title">
                              {orderDetail.order_voucher_code.name}
                            </span>
                          </Row>
                        ) : null}
                        <Row>
                          <span className="main-content title">
                            {t("order_date")}:&nbsp;
                            {moment(orderDetail.created_at).format(
                              t("order_format_date")
                            )}
                          </span>
                        </Row>
                        <Row
                          justify={
                            innerWidth <= WIDTH_MOBILE ? "center" : "start"
                          }>
                          {allowCancelOrder() && (
                            <a
                              className="order-button-reject"
                              style={{
                                pointerEvents:
                                  orderDetail.order_status_reject && "none",
                                color: orderDetail.order_status_reject
                                  ? "#BF9965"
                                  : "#0c3b5d",
                              }}
                              onClick={() => setVisible(true)}>
                              <span className="main-content">
                                {orderDetail.order_status_reject
                                  ? t("btn_rejected_order")
                                  : t("btn_reject_order")}
                              </span>
                            </a>
                          )}
                          <ConfirmCancelOrderModal
                            id={id}
                            visible={visible}
                            setVisible={setVisible}
                            orderDetail={orderDetail}
                            setOrderDetail={setOrderDetail}
                          />
                        </Row>
                      </Col>
                      <Col xs={24} sm={12}>
                        {!!(
                          orderDetail.order_discount_amount &&
                          orderDetail.order_discount_amount !== 0
                        ) && (
                          <Row align="bottom">
                            <Col>
                              <span className="main-content order-discount-amount title order-detail-text-uppercase">
                                {t("order_discount_amount")}
                              </span>
                            </Col>
                            <Col>
                              <span className="main-content order-discount-amount price order-detail-text-uppercase">
                                {`-${orderDetail.order_discount_amount.toLocaleString(
                                  "vi-VN"
                                )} VND`}
                              </span>
                            </Col>
                          </Row>
                        )}
                        <Row align="bottom">
                          <Col>
                            <span className="sub-title order-detail-text-uppercase">
                              {t("order_sumary")}
                            </span>
                          </Col>
                          <Col>
                            <span className="main-title order-detail-bold price order-detail-text-uppercase">
                              {orderDetail.order_price_text} VND
                            </span>
                          </Col>
                        </Row>
                      </Col>
                    </Row>

                    <Row>
                      <Col span={24}>
                        <StepOrderStatus orderDetail={orderDetail} />
                      </Col>
                    </Row>

                    <div
                      className="order-detail-row-container order-user-invoice-info"
                      style={{ flexWrap: breakPoint ? "wrap" : "nowrap" }}>
                      <div className="order-detail-container">
                        <div className="order-detail-row ">
                          <span className="main-content order-detail-bold">
                            {t("address_received")}
                          </span>
                        </div>
                        <div className="order-detail-row">
                          <span className="main-content">
                            {orderDetail.ship_address.full_name}
                          </span>
                        </div>
                        <div className="order-detail-row">
                          <span className="main-content">
                            {orderDetail.ship_address.phone_number}
                          </span>
                        </div>
                        <div className="order-detail-row">
                          <span className="main-content">
                            {orderDetail.ship_address.full_address}
                          </span>
                        </div>
                      </div>

                      {orderDetail.invoice_info && (
                        <div className="order-detail-container">
                          <div className="order-detail-row">
                            <span className="main-content order-detail-bold">
                              {t("user_invoice_info")}
                            </span>
                          </div>
                          <div className="order-detail-row">
                            <span className="main-content">
                              {orderDetail.invoice_info.full_name}
                            </span>
                          </div>
                          <div className="order-detail-row">
                            <span className="main-content">
                              {orderDetail.invoice_info.phone_number}
                            </span>
                          </div>
                          <div className="order-detail-row">
                            <span className="main-content">
                              {t("field_tax_code")}:&nbsp;
                              {orderDetail.invoice_info.tax_code}
                            </span>
                          </div>
                          <div className="order-detail-row">
                            <span className="main-content">
                              {t("field_address_invoice")}:&nbsp;
                              {orderDetail.invoice_info.invoice_address}
                            </span>
                          </div>
                          <div className="order-detail-row">
                            <span className="main-content">
                              {t("field_address_invoice_recevied")}:&nbsp;
                              {orderDetail.invoice_info.invoice_receive_address}
                            </span>
                          </div>
                        </div>
                      )}
                    </div>

                    {(orderDetail.ship_address.note ||
                      orderDetail.reject_reason) && (
                      <div
                        className="order-detail-row-container"
                        style={{ flexWrap: breakPoint ? "wrap" : "nowrap" }}>
                        <div className="order-detail-container">
                          <div className="order-detail-row">
                            <span className="main-content order-detail-bold">
                              {t("order_note")}
                            </span>
                          </div>

                          <div className="order-detail-row">
                            <span className="main-content">
                              {orderDetail.ship_address?.note || ""}
                            </span>
                          </div>

                          {orderDetail.reject_reason && (
                            <div className="order-detail-row">
                              <span className="main-content">
                                <span
                                  style={{
                                    color: "#e94733",
                                    textDecoration: "underline",
                                    fontStyle: "italic",
                                  }}>
                                  Lý do hủy đơn hàng:
                                </span>
                                &nbsp;{orderDetail.reject_reason || ""}
                              </span>
                            </div>
                          )}
                        </div>
                      </div>
                    )}

                    {orderDetail.present_code && (
                      <div
                        className="order-detail-row-container"
                        style={{ flexWrap: breakPoint ? "wrap" : "nowrap" }}>
                        <div className="order-detail-container">
                          <div className="order-detail-row">
                            <span className="main-content order-detail-bold">
                              {t("title_present_code")}
                            </span>
                          </div>

                          <div className="order-detail-row">
                            <span className="main-content">
                              {orderDetail.present_code?.code || "CODE"}
                            </span>
                          </div>
                          <div className="order-detail-row">
                            <span className="main-content">
                              {orderDetail.present_code?.name || "NAME"}
                            </span>
                          </div>
                        </div>
                      </div>
                    )}

                    <Row>
                      <Col xs={24} sm={12}>
                        <div
                          className="order-detail-row-container"
                          style={{
                            flexWrap: breakPoint ? "wrap" : "nowrap",
                          }}>
                          <div className="order-detail-container">
                            <div className="order-detail-row">
                              <span className="main-content order-detail-bold">
                                {t("method_delivery")}
                              </span>
                            </div>
                            <div className="order-detail-row">
                              <span className="main-content">
                                {t("note_fee_delevery")}
                              </span>
                            </div>
                          </div>
                        </div>
                      </Col>
                      <Col xs={24} sm={12}>
                        <div
                          className="order-detail-row-container"
                          style={{
                            flexWrap: breakPoint ? "wrap" : "nowrap",
                          }}>
                          <div className="order-detail-container order-detail-payment-container">
                            <div className="order-detail-row">
                              <span className="main-content order-detail-bold">
                                {t("payment_method")}
                              </span>
                            </div>
                            <div className="order-detail-row">
                              <span className="main-content">
                                {PAYMENT_METHOD_PAYOO_LIST.indexOf(
                                  orderDetail.payment_method
                                ) > -1
                                  ? t(
                                      PAYMENT_METHOD_LABEL[PAYMENT_METHOD_PAYOO]
                                    )
                                  : t(
                                      PAYMENT_METHOD_LABEL[
                                        orderDetail.payment_method
                                      ]
                                    )
                                      .replace("(Tối đa $limit VND)", "")
                                      .replace("(Maximum $limit)", "")}

                                {orderDetail.payment_method ===
                                  PAYMENT_METHOD_TRANSFER && (
                                  <span>
                                    {" - "}
                                    <span className="order-detail-bold">
                                      {
                                        PAYMENT_STATUS_TRANSFER[
                                          orderDetail.payment_status
                                        ]
                                      }
                                    </span>{" "}
                                    <a
                                      className="order-detail-reload-button"
                                      onClick={() => fetchData(id)}>
                                      <ReloadOutlined />
                                    </a>
                                  </span>
                                )}
                              </span>
                            </div>

                            {renderPaymentStatus()}

                            {orderDetail.payment_method ===
                              PAYMENT_METHOD_TRANSFER && (
                              <>
                                <div className="order-detail-row message-payment-transfer">
                                  <div className="internet-banking-info-wrap">
                                    <div className="internet-banking-info-item">
                                      <span className="internet-banking-info-item-label">
                                        Tên tài khoản:
                                      </span>
                                      <span className="internet-banking-info-item-content">
                                        {orderDetail.info_transfer
                                          .payment_name || ""}
                                      </span>
                                    </div>
                                    <div className="internet-banking-info-item">
                                      <span className="internet-banking-info-item-label">
                                        Số tài khoản:
                                      </span>
                                      <span className="internet-banking-info-item-content">
                                        {orderDetail.info_transfer
                                          .payment_number_card || ""}
                                      </span>
                                      <CopyComponent
                                        classNameBtn="internet-banking-info-item-btn"
                                        classNameMessage="internet-banking-info-item-message"
                                        content="Sao chép"
                                        text={
                                          orderDetail.info_transfer
                                            .payment_number_card || ""
                                        }
                                      />
                                    </div>
                                    <div className="internet-banking-info-item">
                                      <span className="internet-banking-info-item-label">
                                        Tại ngân hàng:
                                      </span>
                                      <span className="internet-banking-info-item-content">
                                        {orderDetail.info_transfer
                                          .payment_bank || ""}
                                      </span>
                                    </div>
                                    <div className="internet-banking-info-item">
                                      <span className="internet-banking-info-item-label">
                                        Số tiền:
                                      </span>
                                      <span className="internet-banking-info-item-content">
                                        {orderDetail.order_price_text} VND
                                      </span>
                                    </div>
                                    <div className="internet-banking-info-item">
                                      <span className="internet-banking-info-item-label">
                                        Nội dung:
                                      </span>
                                      <span className="internet-banking-info-item-content">
                                        {orderDetail.info_transfer
                                          .payment_note || ""}
                                      </span>
                                      <CopyComponent
                                        classNameBtn="internet-banking-info-item-btn"
                                        classNameMessage="internet-banking-info-item-message"
                                        content="Sao chép"
                                        text={
                                          orderDetail.info_transfer
                                            .payment_note || ""
                                        }
                                      />
                                    </div>
                                  </div>
                                </div>
                              </>
                            )}

                            {orderDetail.payment_transacion_id &&
                              orderDetail.payment_method ===
                                PAYMENT_METHOD_VTPAY && (
                                <OrderPaymentCode
                                  paymentCode={
                                    orderDetail.payment_transacion_id.payment_id
                                  }
                                  paymentNote={t("payment_viettelpay_note")}
                                />
                              )}
                            {orderDetail.payment_transacion_id &&
                              !_.isEmpty(
                                orderDetail.payment_transacion_id.payment_code
                              ) && (
                                <OrderPaymentCode
                                  paymentCode={
                                    orderDetail.payment_transacion_id
                                      .payment_code
                                  }
                                  paymentNote={t("payment_payoo_note")}
                                />
                              )}
                          </div>
                        </div>
                      </Col>
                    </Row>

                    <Row>
                      <Col span={24}>
                        <Row style={{ paddingLeft: 30, margin: "30px 0" }}>
                          <span className="sub-title order-detail-text-uppercase">
                            {t("infomation_order")}
                          </span>
                        </Row>

                        <Row>
                          {orderDetail.products.map((item: any, index: any) => (
                            <ProductOrder product={item} key={index} />
                          ))}
                        </Row>
                      </Col>
                    </Row>
                    {Array.isArray(
                      orderDetail.products
                        .map((product: any) => product?.product_gifts)
                        .flat()
                        .concat(orderDetail.order_promotions)
                    ) &&
                    orderDetail.products
                      .map((product: any) => product?.product_gifts)
                      .flat()
                      .concat(orderDetail.order_promotions).length ? (
                      <Row>
                        <Col span={24}>
                          <Row style={{ paddingLeft: 30, margin: "30px 0" }}>
                            <span className="sub-title order-detail-text-uppercase">
                              {t("gifts_order")}
                            </span>
                          </Row>

                          <Row>
                            {orderDetail.products.map((product: any) =>
                              product?.product_gifts.map(
                                (gift: any, index: any) => (
                                  <ProductOrderGift gift={gift} key={index} />
                                )
                              )
                            )}
                            {orderDetail.order_promotions?.map(
                              (gift: any, index: any) => (
                                <ProductOrderGift gift={gift} key={index} />
                              )
                            )}
                          </Row>
                        </Col>
                      </Row>
                    ) : null}

                    <Row justify="center">
                      <Col xs={24} sm={20}>
                        <Row style={{ borderTop: "1px solid" }}></Row>
                      </Col>
                    </Row>
                  </div>
                ) : (
                  <div className="order-detail-failed sub-title">
                    {t("look_up_order_failed")}
                  </div>
                )}
              </div>
            </div>
          </Col>
        </Row>
      </Col>
    </Row>
  );
});

export default ProfileOrderDetail;
